import { Star, Quote } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  return (
    <section id="depoimentos" className="relative border-t border-[#1A1A20] bg-[#0A0A0C]">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
        <SectionHeading
          number="07"
          label="Depoimentos"
          title="Quem trabalhou comigo,"
          accent="recomenda."
        />

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.12}>
              <figure
                data-testid={`testimonial-card-${t.id}`}
                className="card-glow relative flex h-full flex-col rounded-2xl border border-[#22222A] bg-[#101014] p-8"
              >
                <Quote className="absolute right-6 top-6 h-8 w-8 text-[#E50914]/20" />
                <div className="flex gap-1" data-testid={`testimonial-stars-${t.id}`}>
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-[#E50914] text-[#E50914]" />
                  ))}
                </div>
                <blockquote className="mt-6 flex-1 text-sm leading-relaxed text-zinc-300 sm:text-base">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-8 flex items-center gap-4 border-t border-[#1A1A20] pt-6">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#E50914]/40 bg-[#E50914]/10 font-display text-sm font-extrabold text-[#FF2A3B]">
                    {t.initials}
                  </span>
                  <div>
                    <div className="font-display text-sm font-bold text-zinc-100">{t.name}</div>
                    <div className="mt-0.5 font-mono-code text-[10px] uppercase tracking-wider text-zinc-500">
                      {t.role}
                    </div>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
